import React from 'react'

const GoalArea = () => {
    return (
        <div className="goal-area space">
            <div className="container">
                <div className="row align-items-end">
                    <div className="col-lg-6">
                        <div className="title-area">
                            <span className="sub-title">
                                <img src="assets/img/icon/title_left.svg" alt="shape" />
                                Our Goal
                            </span>
                            <h2 className="sec-title style2">Partnering Business for Success</h2>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="goal-title-area">
                            <p className="">
                                There are many variati of passages of engineer's available. have
                                suffered alteration in engineer's available
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="goal-tabs-wrapper">
                        <div
                            className="nav nav-tabs goal-tabs-tabs"
                            id="nav-tab"
                            role="tablist"
                        >
                            <button
                                className="nav-link"
                                id="nav-step1-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step1"
                                type="button"
                            >
                                Biography
                            </button>
                            <button
                                className="nav-link"
                                id="nav-step2-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step2"
                                type="button"
                            >
                                Education
                            </button>
                            <button
                                className="nav-link active"
                                id="nav-step3-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step3"
                                type="button"
                            >
                                Experience
                            </button>
                            <button
                                className="nav-link"
                                id="nav-step4-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-step1"
                                type="button"
                            >
                                Biography
                            </button>
                        </div>
                        <div className="tab-content" id="nav-tabContent">
                            <div className="tab-pane fade" id="nav-step1" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Performance Enhancement Partners
                                            </h4>
                                            <p>Strategic Solutions Pro</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Management Mastery Consultan</h4>
                                            <p>Profitability Maximizers</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Operational Excellence Solutions
                                            </h4>
                                            <p>Framer Designer &amp; Developer</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Transformational Strategy</h4>
                                            <p>Efficiency Experts</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="nav-step2" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Performance Enhancement Partners
                                            </h4>
                                            <p>Strategic Solutions Pro</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Management Mastery Consultan</h4>
                                            <p>Profitability Maximizers</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Operational Excellence Solutions
                                            </h4>
                                            <p>Framer Designer &amp; Developer</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Transformational Strategy</h4>
                                            <p>Efficiency Experts</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade active show"
                                id="nav-step3"
                                role="tabpanel"
                            >
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Performance Enhancement Partners
                                            </h4>
                                            <p>Strategic Solutions Pro</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Management Mastery Consultan</h4>
                                            <p>Profitability Maximizers</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Operational Excellence Solutions
                                            </h4>
                                            <p>Framer Designer &amp; Developer</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Transformational Strategy</h4>
                                            <p>Efficiency Experts</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="tab-pane fade" id="nav-step4" role="tabpanel">
                                <div className="goal-list_wrapper">
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Performance Enhancement Partners
                                            </h4>
                                            <p>Strategic Solutions Pro</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Management Mastery Consultan</h4>
                                            <p>Profitability Maximizers</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">
                                                Operational Excellence Solutions
                                            </h4>
                                            <p>Framer Designer &amp; Developer</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="goal-content_wrapp">
                                        <img src="assets/img/icon/angles-left.svg" alt="Gohub" />
                                        <div className="goal-content">
                                            <h4 className="box-title">Transformational Strategy</h4>
                                            <p>Efficiency Experts</p>
                                            <div className="checklist">
                                                <ul>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Success Accelerators
                                                    </li>
                                                    <li>
                                                        <i className="fas fa-check" />
                                                        Started politician Club
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default GoalArea